import React from "react";
import { FiDownload, FiFileText } from "react-icons/fi";

const FORMAT_COLORS = { PDF: "#ef4444", CSV: "#10b981", Excel: "#3b82f6" };

const IrrReportsPanel = ({ d }) => (
  <div className="irr-reports-panel">

    <div className="irr-section-title">Reports & Data Export</div>
    <div className="irr-section-sub">Download system reports in PDF, CSV or Excel format</div>

    <div className="irr-report-grid">
      {d.reports.map(r => (
        <div key={r.id} className="irr-report-card">
          <div className="irr-rc-top">
            <FiFileText size={20} color="#667eea" />
            <div>
              <div className="irr-rc-name">{r.name}</div>
              <div className="irr-rc-desc">{r.desc}</div>
            </div>
          </div>
          <div className="irr-rc-footer">
            <span className="irr-rc-gen">Generated: {r.generated}</span>
            <div className="irr-rc-btns">
              {r.formats.map(fmt => (
                <button key={fmt} className="irr-dl-btn" style={{ background: FORMAT_COLORS[fmt] + "18", color: FORMAT_COLORS[fmt], borderColor: FORMAT_COLORS[fmt] }}>
                  <FiDownload size={12} /> {fmt}
                </button>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>

    <div className="irr-compliance-note">
      <FiFileText size={14} color="#667eea" />
      All reports are generated from live system data and can be scheduled for automatic email delivery. Contact your admin to set up automated reporting.
    </div>
  </div>
);

export default IrrReportsPanel;
